import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBagShopping, faBars, faLeaf} from "@fortawesome/pro-regular-svg-icons";
import {useCart} from "../../providers/queryClient";
import {useTranslation} from 'react-i18next';
import {Dialog, Transition} from "@headlessui/react";
import {LanguageSelector} from "./LanguageSelector";
import {Link} from "react-router-dom";

const navigation = {
    pages: [
        {name: 'START', href: '/'},
        {name: 'CONFIGURATOR', href: '/configurator'},
        {name: 'CONTACT', href: '/contact'},
    ],
}

const Header = () => {
    const {data} = useCart();
    const {t} = useTranslation();
    const [open, setOpen] = useState(false)

    return (
        <>
            <Transition show={open}>
                <Dialog className="relative z-40 lg:hidden" onClose={setOpen}>
                    <Transition.Child
                        enter="transition-opacity ease-linear duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="transition-opacity ease-linear duration-300"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25"/>
                    </Transition.Child>

                    <div className="fixed inset-0 z-40 flex">
                        <Transition.Child
                            enter="transition ease-in-out duration-300 transform"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="transition ease-in-out duration-300 transform"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel
                                className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                                <div className="flex px-4 pb-2 pt-5">
                                    <button
                                        type="button"
                                        className="-m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
                                        onClick={() => setOpen(false)}
                                    >
                                        <span className="sr-only">Close menu</span>
                                        {/*<XMarkIcon className="h-6 w-6" aria-hidden="true"/>*/}
                                    </button>
                                </div>

                                <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                                    {navigation.pages.map((page) => (
                                        <div key={page.name} className="flow-root">
                                            <a href={page.href} className="-m-2 block p-2 font-medium text-gray-900">
                                                {t('HEADER.' + page.name)}
                                            </a>
                                        </div>
                                    ))}
                                </div>

                                <div className="border-t border-gray-200 px-4 py-6">
                                    <a href="#" className="-m-2 flex items-center p-2">
                                        <img
                                            src="https://tailwindui.com/img/flags/flag-canada.svg"
                                            alt=""
                                            className="block h-auto w-5 flex-shrink-0"
                                        />
                                        <span className="ml-3 block text-base font-medium text-gray-900">CAD</span>
                                        <span className="sr-only">, change currency</span>
                                    </a>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>

            <header className="relative bg-gray-50">
                <nav aria-label="Top" className="mx-auto w-screen px-4 sm:px-6 lg:px-8">
                    <div className="border-b border-gray-200">
                        <div className="flex h-16 items-center justify-between">
                            <div className="flex flex-1 items-center lg:hidden">
                                <button
                                    type="button"
                                    className="-ml-2 rounded-md bg-white p-2 text-gray-400"
                                    onClick={() => setOpen(true)}
                                >
                                    <span className="sr-only">Open menu</span>
                                    <FontAwesomeIcon icon={faBars} className="h-5 w-5"/>
                                </button>
                            </div>

                            {/* Flyout menus */}
                            <div className="hidden lg:block lg:flex-1 lg:self-stretch">
                                <div className="flex h-full space-x-8">
                                    {navigation.pages.map((page) => (
                                        <a
                                            key={page.name}
                                            href={page.href}
                                            className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
                                        >
                                            {t('HEADER.' + page.name)}
                                        </a>
                                    ))}
                                </div>
                            </div>

                            {/* Logo */}
                            <a href="#" className="flex">
                                <span className="sr-only">Your Company</span>
                                <FontAwesomeIcon color={'#FEC106'} icon={faLeaf} className="h-8 w-auto"/>
                            </a>

                            <div className="flex flex-1 items-center justify-end">

                                <LanguageSelector />

                                {/* Cart */}
                                <div className="ml-4 flow-root lg:ml-6">
                                    <Link to="/cart" className="group -m-2 flex items-center p-2">
                                        <FontAwesomeIcon
                                            className="h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                                            icon={faBagShopping}/>
                                        <span
                                            className="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-800">{data?.items.length || 0}</span>
                                        <span className="sr-only">items in cart, view bag</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>
        </>
    );
}

export default Header;